import React, { useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import MapContext from "../MapContext";
import { Switch } from "@progress/kendo-react-inputs";
import { getMapLayerById, toggleSnap } from "../utils/mapUtils";
import { updateSnappable, setSnappingReady } from "../../redux/setConfigSlice";
import { addSnapInteractions, removeSnapInteractions } from "../utils/mapUtils";
import { filterReadLayers } from "../../permissionUtils";
import { Tooltip } from "@progress/kendo-react-tooltip";

export const Snapping = ({ setSnapping, snapping }) => {
    const layerVisibility = useSelector((state) => state.configData.layerVisProperties);
    const layerPermissions = useSelector(
        (state) => state.authorizedPermissions.layerPermissions
    );
    const snappableLayers = filterSnappableLayers(layerVisibility, layerPermissions);
    const snappingReady = useSelector((state) => state.configData.snappingReady);
    const { map } = useContext(MapContext);
    const dispatch = useDispatch();

    useEffect(() => {
        if (snappingReady.ready === false || snapping === false) return;
        removeSnapInteractions(map, snappableLayers);

        addSnapInteractions(map, snappableLayers);
        return () => {
            dispatch(setSnappingReady(false));
        };
    }, [snappingReady]);

    useEffect(() => {
        if (snapping === true) {
            addSnapInteractions(map, snappableLayers);
        }
        return () => {
            if (snapping === true) {
                removeSnapInteractions(map, snappableLayers);
            }
        };
    }, [snapping]);

    return (
        <>
            {" "}
            <h4>Snapping</h4>
            <Switch
                onChange={() => setSnapping(!snapping)}
                checked={snapping}
                id="snap-controls-toggle"
            />
            {snapping === true &&
                snappableLayers.map((layer) => {
                    const layerVisible = getMapLayerById(map, layer.Id).getVisible();
                    return (
                        <div className="snap-controls" key={layer.Id}>
                            <span
                                title={
                                    !layerVisible
                                        ? "Turn layer on to snap to it"
                                        : undefined
                                }>
                                <Switch
                                    onChange={() => {
                                        dispatch(
                                            updateSnappable([layer.Id, !layer.Snappable])
                                        );
                                        toggleSnap(map, layer, !layer.Snappable);
                                    }}
                                    checked={layer.Snappable && layerVisible}
                                    size="small"
                                    className={`snap-switch`}
                                    disabled={!layerVisible}
                                />
                            </span>
                            <div
                                className={`snap-label${
                                    !layerVisible ? " snap-disabled" : ""
                                }`}>
                                {layer.DisplayName}
                            </div>
                        </div>
                    );
                })}
        </>
    );
};

/**
 * Filter layers to snap to based on permissions and snappability
 * @param {Object[]} layers Layers from redux
 * @param {import("../../permissionUtils").MergedLayerPermission} layerPermissions Layer permissions from redux
 * @returns {Object[]} Filtered layers that are readable and snappable
 */
const filterSnappableLayers = (layers, layerPermissions) => {
    const readableLayers = filterReadLayers(layers, layerPermissions);
    const snappableLayers = readableLayers.filter((l) => l.Snappable !== undefined);
    return snappableLayers;
};
